import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getBotRoutePath } from '../../../config/getBotConfig';
import pathRoutes from '../../../enums/pathRoutes';
import classes from './BotListItem.module.css';

export default function BotListItem({
  projectKey,
  botName,
  routePath,
  headerBotName,
  subjectName,
  iconUrl,
  subjectIconUrl,
  isActive,
  approvedByPmr,
  showDivider = false,
  onAfterSelect,
}) {
  const navigate = useNavigate();
  const { texts } = useSelector((state) => state.translate);
  const displayName = headerBotName || botName;
  const showSubjectRow = approvedByPmr || Boolean(subjectName) || Boolean(subjectIconUrl);

  const handleClick = () => {
    const nextPath = routePath || getBotRoutePath(projectKey, botName);
    navigate(`/${pathRoutes.PORTAL}/${nextPath}`);
    onAfterSelect?.();
  };

  return (
    <button
      type="button"
      className={[
        classes.Item,
        isActive ? classes.Active : '',
        showDivider ? classes.WithDivider : '',
      ].filter(Boolean).join(' ')}
      onClick={handleClick}
      aria-current={isActive ? 'page' : undefined}
    >
      <div className={classes.Avatar} aria-hidden="true">
        {iconUrl ?
          <img src={iconUrl} alt="" className={classes.AvatarImg} />
          :
          <span className={classes.AvatarLetter}>{(headerBotName || botName || '?').charAt(0)}</span>
        }
      </div>
      <div className={classes.Info}>
        <span className={classes.BotName}>{displayName}</span>
        {showSubjectRow ?
          <span className={classes.SubjectRow}>
            {subjectIconUrl ?
              <img src={subjectIconUrl} alt="" className={classes.SubjectIcon} />
              : null}
            {approvedByPmr ?
              <span className={classes.botSubjectName}>
                <span className={classes.MapmarPrefix}>{texts.botMapmarPrefix}</span>
                {subjectName ?
                  <span className={classes.SubjectNamePart}> {subjectName}</span>
                  : null}
              </span>
              : subjectName ?
                <span className={classes.botSubjectName}>{subjectName}</span>
                : null}
          </span>
          : null}
      </div>
    </button>
  );
}
